module.exports = __webpack_public_path__ + "static/media/backArrow.8de020e7.svg";